export default "__VITE_ASSET__F7vr1sYU__"